"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAccessibleDashboardsMap = exports.selectAccessibleDashboards = void 0;
// (C) 2021 GoodData Corporation
var toolkit_1 = require("@reduxjs/toolkit");
var objRefMap_1 = require("../../../_staging/metadata/objRefMap");
var accessibleDashboardsEntityAdapter_1 = require("./accessibleDashboardsEntityAdapter");
var selectSelf = toolkit_1.createSelector(function (state) { return state; }, function (state) { return state.accessibleDashboards; });
var adapterSelectors = accessibleDashboardsEntityAdapter_1.accessibleDashboardsEntityAdapter.getSelectors(selectSelf);
/**
 * Select all accessible dashboard in project.
 *
 * @alpha
 */
exports.selectAccessibleDashboards = adapterSelectors.selectAll;
/**
 * Select all accessible dashboard in project and returns them in a mapping of obj ref to the insight object.
 *
 * @alpha
 */
exports.selectAccessibleDashboardsMap = toolkit_1.createSelector(exports.selectAccessibleDashboards, function (dashboards) {
    return objRefMap_1.newMapForObjectWithIdentity(dashboards);
});
//# sourceMappingURL=accessibleDashboardsSelectors.js.map